<template>
  <component :is="main_component" :profile-photo-src="profilePhotoSrc">
    <template #networkLogo>
      <img v-if="networkLogo" class="h-auto max-h-11 w-auto bg-white my-auto" :class="!logo ? 'max-h-[35px]' : ''" :src="networkLogo" alt="Your Company" />
    </template>
    <template #logo>
      <img v-if="logo" class="h-auto max-h-[35px] w-auto bg-white pl-8 my-auto" :src="logo" alt="Your Company" />
    </template>
    <template #content>
      <router-view></router-view>
    </template>
  </component>

  <notifications>
    <template #body="props">
      <NotificationsComponent :response="props"/>
    </template>
  </notifications>
  <modals-container></modals-container>
</template>

<script>
import MainComponent from "../../components/tailwind_ui/components/Main/MainComponent.vue";
import NotificationsComponent from "../../components/tailwind_ui/components/NotificationsComponent.vue";
import {ModalsContainer} from "vue-final-modal";

export default {
  name: 'MainView',
  props: {
    profilePhotoSrc: {
      type: String,
      default: '/img/user.png',
    },
    logo: {
      type: String,
      default: null,
    },
    networkLogo: {
      type: String,
      default: null,
    },
    main_component: {
      type: String,
      default: null,
    },
    // saved in vuex
    user: {
      type: Object,
      default: null,
    },
    account: {
      type: Object,
      default: null,
    },
    userIsAccountLevelAdmin: {
      type: Boolean,
      default:false,
    },
    userIsAuditor: {
      type: Boolean,
      default:false,
    },
    userIsQuestionAdmin: {
      type: Boolean,
      default:false,
    },
    onlyPilotNetwork: {
      type: Boolean,
      default:false,
    }
  },
  components: {
    ModalsContainer,
    MainComponent,
    NotificationsComponent,
  },
  created() {
    this.$store.commit('addUserIsAccountLevelAdmin', this.userIsAccountLevelAdmin)
    this.$store.commit('addUserIsAuditor', this.userIsAuditor)
    this.$store.commit('addUserIsQuestionAdmin', this.userIsQuestionAdmin)
    this.$store.commit('addOnlyPilotNetwork', this.onlyPilotNetwork)
    this.$store.commit('addUser', this.user)
    this.$store.commit('addAccount', this.account)
  }
}
</script>